import angular from 'angular';
import PortainerError from 'ShbDeployer/error';

class KubernetesReplicaSetService {
  /* @ngInject */
  constructor($async, KubernetesReplicaSets) {
    this.$async = $async;
    this.KubernetesReplicaSets = KubernetesReplicaSets;

    this.getAllAsync = this.getAllAsync.bind(this);
  }

  /**
   * GET
   */
  async getAllAsync(namespace) {
    try {
      const data = await this.KubernetesReplicaSets(namespace).get().$promise;
      return data.items;
    } catch (err) {
      throw new PortainerError('Не удалось получить объекты ReplicaSet', err);
    }
  }

  get(namespace) {
    return this.$async(this.getAllAsync, namespace);
  }
}

export default KubernetesReplicaSetService;
angular.module('shbdeployer.kubernetes').service('KubernetesReplicaSetService', KubernetesReplicaSetService);
